import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { SessionHistory } from './session-history';
export { SessionHistory };
import { sessionHistorySchema } from '@schemas/business-objects/session-history';
import { StudentFormGroup } from './student-form-group';

export class SessionHistoryFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    date: SchemaFormControl;
    attendanceType: SchemaFormControl;
    studentId: SchemaFormControl;
    student: StudentFormGroup;
  };

  declare value: Partial<SessionHistory>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(sessionHistorySchema, SessionHistory, data, options);
  }

  get object(): SessionHistory {
    return new SessionHistory(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'student':
        return new StudentFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<SessionHistory[]> {
    return SessionHistory.find(filter);
  }

  static async findOne(filter?: any): Promise<SessionHistory | null> {
    return SessionHistory.findOne(filter);
  }

  static async findById(id: number, filter?: any): Promise<SessionHistory> {
    return SessionHistory.findById(id, filter);
  }

  static async create(data: Partial<SessionHistory>): Promise<SessionHistory> {
    return SessionHistory.create(data as any);
  }

  static async updateById(
    id: number,
    updates: Partial<SessionHistory>,
  ): Promise<SessionHistory> {
    return SessionHistory.updateById(id, updates as any);
  }

  static async deleteById(id: number): Promise<boolean> {
    return SessionHistory.deleteById(id);
  }
}

export class SessionHistoryFormArray extends PersistedFormArray {
  readonly entityName = 'SessionHistory' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(sessionHistorySchema, SessionHistory, options);
  }

  protected override createItemGroup() {
    return new SessionHistoryFormGroup();
  }

  get array(): SessionHistory[] {
    return this.controls.map((group: SessionHistoryFormGroup) => group.object);
  }
}

export class SessionHistoryPersistedArray extends PersistedArray<SessionHistory> {
  readonly entityName = 'SessionHistory' as const;

  constructor(options?: PersistedArrayOptions) {
    super(SessionHistory, options);
  }
}
